export class TemplateImportError extends Error {
  name = "TemplateImportError";

  constructor(cause: string) {
    super("Template cannot be imported.", { cause });
  }
}
